<a [profile]="item" class="icon">
  <app-avatar [src]="item.icon" [placeholder]="item | initials" class="img-fluid"></app-avatar>
</a>
<div class="ceil-content">
  <div class="ceil-text">
    <div class="ceil-title">
      <a [profile]="item"> {{ item.name | textTruncate: 50 }} </a>
      <svg viewBox="0 0 20 20" *ngIf="item?.is_creditable" class="verify-icon">
        <use href="#verified" />
      </svg>
    </div>
    <div class="ceil-sub-title"> {{item.type_name}} </div>
    <div class="ceil-description"> {{item.description | textTruncate}} </div>
    <!-- <div class="ceil-actions">
      <a href="#">Create club</a>
    </div> -->
  </div>
</div>
